/* src/app/views/template/components/edit-template-menu/edit-template-marketing-menu/edit-template-marketing-featured-category-menu/edit-template-featured-category-section/edit-template-featured-category-section.component.scss */
/*# sourceMappingURL=edit-template-featured-category-section.component.css.map */
